'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useState, useMemo } from 'react';
import { useIsomorphicEffect } from '@s7/hooks';
import { isString } from '@s7/utils';
import { FooterAnalyticsProvider } from './analytics.js';
import { useFooterQuery } from '../domain/api/Footer.js';
import { Footer } from '../../Footer/Footer.js';
import { SearchContainer } from './features/SearchContainer/SearchContainer.js';
import { NavigationContainer } from './features/NavigationContainer/NavigationContainer.js';
import { CallCenterContainer } from './features/CallCenterContainer/CallCenterContainer.js';
import { AppContainer } from './features/AppContainer/AppContainer.js';
import { SubscriptionsContainer } from './features/SubscriptionsContainer/SubscriptionsContainer.js';
import { SecondaryLinksContainer } from './features/SecondaryLinksContainer/SecondaryLinksContainer.js';
import { SocialContainer } from './features/SocialContainer/SocialContainer.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var FOOTER_BLOCKS = {
    search: SearchContainer,
    productNavigation: NavigationContainer,
    mainNavigation: NavigationContainer,
    callCenter: CallCenterContainer,
    appBlock: AppContainer,
    subscriptions: SubscriptionsContainer,
    secondaryLinks: SecondaryLinksContainer,
    social: SocialContainer
};
/**
 * https://github.com/vercel/next.js/blob/11b01e06dfe1508c84d2aa60d8adcdc916cdd46d/packages/next/src/client/link.tsx#L263
 * */ var FooterWidgetContainer = function(props) {
    var _data_content;
    var service = props.service, containerProps = props.containerProps, renderSkeleton = props.renderSkeleton, _props_render = props.render, render = _props_render === void 0 ? {} : _props_render, _props_custom = props.custom, custom = _props_custom === void 0 ? {} : _props_custom, _props_handlers = props.handlers, handlers = _props_handlers === void 0 ? {} : _props_handlers, linkProps = props.linkProps, analytics = props.analytics;
    var _useFooterQuery = useFooterQuery(service), data = _useFooterQuery[0], loading = _useFooterQuery[1].loading;
    var _useState = useState(false), isClient = _useState[0], setIsClient = _useState[1];
    useIsomorphicEffect(function() {
        setIsClient(true);
    }, []);
    var topic = useMemo(function() {
        return analytics.createTopic(function(_eventName, payload) {
            return _extends({
                step: "footer"
            }, payload);
        });
    }, [
        analytics
    ]);
    return /*#__PURE__*/ jsx(FooterAnalyticsProvider, {
        value: {
            topic: topic
        },
        children: isClient && /*#__PURE__*/ jsx(Footer, _extends({
            linkMapper: linkProps
        }, containerProps, {
            children: loading ? renderSkeleton == null ? void 0 : renderSkeleton() : data == null ? void 0 : (_data_content = data.content) == null ? void 0 : _data_content.map(function(param) {
                var key = param.key, content = param.content;
                var Component = FOOTER_BLOCKS[key];
                if (!Component) {
                    return null;
                }
                var _$props = _extends({}, custom[key], content, render[key], {
                    handlers: handlers[key]
                });
                if (key === "search") {
                    var _props_service, _data_content_find, _data_content_find1;
                    var isValidService = "service" in _$props && isString((_props_service = _$props.service) == null ? void 0 : _props_service.url);
                    if (!isValidService) {
                        return;
                    }
                    return /*#__PURE__*/ jsx(Component, _extends({}, _$props, {
                        mainNavigation: (_data_content_find = data.content.find(function(item) {
                            return item.key === "mainNavigation";
                        })) == null ? void 0 : _data_content_find.content,
                        productNavigation: (_data_content_find1 = data.content.find(function(item) {
                            return item.key === "productNavigation";
                        })) == null ? void 0 : _data_content_find1.content
                    }), key);
                }
                return /*#__PURE__*/ jsx(Component, _extends({}, _$props), key);
            })
        }))
    });
};

export { FooterWidgetContainer };
